import { Navigate } from 'react-router-dom';

// Bookmarks to the former administration area return through the medical access guard.
const retiredRoutes = ['/admin', '/mgmt/*'].map((path) => ({
    path,
    element: <Navigate to="/" replace />
}));

export default retiredRoutes;
